<template>
   <span class="statistics-global-filter__filter">
        <select name="consultant_level" id="consultant_level" class="form-control select2-rendered" data-allow-clear="false" ref="filter">
            <option :value="option.value" v-for="option in config.options" :selected="option.selected">{{ option.label }}</option>
        </select>
    </span>
</template>

<script>
    export default {
        props: ['config'],
        created() {
            this.$nextTick(() => {
                let that = this;
                $(this.$refs.filter).on('change', function () {
                    let val = $(this).val();
                    let selected = _.find(that.config.options, function (o) {
                        return val == o.value;
                    });

                    Event.$emit('consultantLevelFilterChanged', selected);
                });
            });

            Event.$emit('consultantLevelFilterChanged', this.config.options[0]);
        },
    }
</script>



// WEBPACK FOOTER //
// resources/js/app/components/statistics-super-commissions/partials/global_filters/consultantLevel.vue